"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunitySearchDto = instanceOfOrientationOpportunitySearchDto;
exports.OrientationOpportunitySearchDtoFromJSON = OrientationOpportunitySearchDtoFromJSON;
exports.OrientationOpportunitySearchDtoFromJSONTyped = OrientationOpportunitySearchDtoFromJSONTyped;
exports.OrientationOpportunitySearchDtoToJSON = OrientationOpportunitySearchDtoToJSON;
exports.OrientationOpportunitySearchDtoToJSONTyped = OrientationOpportunitySearchDtoToJSONTyped;
const State_1 = require("./State");
/**
 * Check if a given object implements the OrientationOpportunitySearchDto interface.
 */
function instanceOfOrientationOpportunitySearchDto(value) {
    return true;
}
function OrientationOpportunitySearchDtoFromJSON(json) {
    return OrientationOpportunitySearchDtoFromJSONTyped(json, false);
}
function OrientationOpportunitySearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startFromRecord': json['startFromRecord'] == null ? undefined : json['startFromRecord'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'minimumPayRate': json['minimumPayRate'] == null ? undefined : json['minimumPayRate'],
        'jurisdictions': json['jurisdictions'] == null ? undefined : (json['jurisdictions'].map(State_1.StateFromJSON)),
        'specialtyCodes': json['specialtyCodes'] == null ? undefined : json['specialtyCodes'],
        'noSpecialty': json['noSpecialty'] == null ? undefined : json['noSpecialty'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'radiusInMiles': json['radiusInMiles'] == null ? undefined : json['radiusInMiles'],
        'facilities': json['facilities'] == null ? undefined : json['facilities'],
    };
}
function OrientationOpportunitySearchDtoToJSON(json) {
    return OrientationOpportunitySearchDtoToJSONTyped(json, false);
}
function OrientationOpportunitySearchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startFromRecord': value['startFromRecord'],
        'profileId': value['profileId'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'minimumPayRate': value['minimumPayRate'],
        'jurisdictions': value['jurisdictions'] == null ? undefined : (value['jurisdictions'].map(State_1.StateToJSON)),
        'specialtyCodes': value['specialtyCodes'],
        'noSpecialty': value['noSpecialty'],
        'lat': value['lat'],
        'lng': value['lng'],
        'radiusInMiles': value['radiusInMiles'],
        'facilities': value['facilities'],
    };
}
//# sourceMappingURL=OrientationOpportunitySearchDto.js.map